import { render, staticRenderFns } from "./hit_table.vue?vue&type=template&id=12fb81a7&"
import script from "./hit_table.vue?vue&type=script&lang=js&"
export * from "./hit_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports